module.exports = {
  setToken: setToken,
  getToken: getToken
};
var sessionToken = undefined;
function setToken(value) {
  sessionToken = value;
}
function getToken() {
  return sessionToken;
}